import { QueryResult, useQuery, OperationVariables } from '@apollo/client';
import GET_DOMAINS from 'graph/queries/assessment-reports/get-domains-query';
import { Domain, StoreTypename } from 'types';

export type DomainStoreState = {
  domains?: Domain[];
};

export type DomainStoreDispatch = {
  domainRefetch: any;
};

export type DomainStore = [DomainStoreState, DomainStoreDispatch];

export const getDefaultDomainStoreState = (): any => ({
  __typename: StoreTypename.DOMAIN,
});

const useDomainStore = (variables?: OperationVariables): DomainStore => {
  const { data, refetch: domainRefetch }: QueryResult<{ domains: Domain[] }> = useQuery(
    GET_DOMAINS,
    { variables }
  );

  return [
    {
      ...(data && { domains: [...data.domains] }),
    },
    {
      domainRefetch,
    },
  ];
};

export default useDomainStore;
